<div class="activity">
  <div class="table-actions">
    <app-ai-activity-filters class="full-width" [pageFilters]="pageFilters"></app-ai-activity-filters>
  </div>
  <div class="table-header">
    <div class="resources-amount" *ngIf="totalItems > -1">
      {{ 'common.found' | labelsProvider }} {{ totalItems | number }}
      {{ 'steps' }}
    </div>
  </div>
  <div class="table">
    <app-ai-activity-vertical-filters
      [ngClass]="{ 'filters-all': isFiltersMenuOpen }"
      (optionOnSelection)="tablesFiltersChange($event)"
      [pageFilters]="pageFilters"
      [isFiltersMenuOpen]="isFiltersMenuOpen"
      (filtersOnMenuStateChange)="filtersOnMenuStateChange($event)"
    >
    </app-ai-activity-vertical-filters>
    <app-prime-table
      #table
      [ngClass]="!isFiltersMenuOpen ? 'table-collapsed-menu' : 'table-component'"
      queryParamProperty="agentStep"
      [data$]="agentStepResourcesCurrentPage$"
      [rowsPerPage]="defaultPageSize"
      [columns]="columns()"
      [isLoading]="(isLoading$ | async) === true"
      [withCheckboxSelection]="false"
      [sortedColumn$]="pageFilters.sortedColumn$"
      [pageInfo]="pageInfo$.value"
      tableNotFoundText="You don't have any resources"
      (rowUnselected)="rowUnselected()"
      (rowSelected)="rowSelected($event)"
      tableNotFoundIcon="assets/images/common/no-results-found.svg"
      (pageOnChange)="onPagination($event)"
    />
  </div>
</div>
